<template>
  <v-row justify="center">
    <v-dialog
      class="fontcolor"
      v-model="alertDialog"
      persistent
      max-width="510"
    >
      <v-card>
       <v-card-title>
        </v-card-title>
        <v-card-text>
          {{ discription }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            outlined
            class='fontcolor'
            color="green darken-1"
            @click="cancel"
          >
          <v-icon dark>mdi-check</v-icon>
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ['alertDialog', 'discription', 'cancel']
}
</script>
